import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (FH110 / FH111 / FH113)
// ============================================================

export interface FH111 {
  fh111_01: string;    // 單號(FK)
  fh111_02: number;    // 序號固定=1
  fh111_03: number;    // 項次
  fh111_11: string;
  fh111_12: string;    // 款項別
  fh111_13: string;
  fh111_14: string;
  fh111_15: number;    // 請款金額
  fh111_151: number;
  fh111_16: number;
  fh111_17: string;
  fh111_18: number;
  fh111_19: string;    // 費用代號
  fh111_20: string;
  fh111_21: string | null;
  fh111_22: number;
  fh111_23: number;
  fh111_24: number;
  fh111_25: string;
  fh111_26: string;
  fh111_27: string | null;
  fh111_30: number;
  fh111_37: string;    // 備註
  fh111_90: number;
}

export interface FH113 {
  fh113_01: string;    // 單號(FK)
  fh113_02: number;    // 序號
  fh113_11: string;    // 審核人
  fh113_12: string | null; // 審核日期
  fh113_13: number;    // 審核金額
  fh113_16: number;    // 累計金額
  fh113_90: number;
}

export interface FH081 {
  fh081_01: string;          // 主鍵
  fh081_02: string;          // 請款單號 (FK)
  fh081_03: string;          // 沖帳單號
  fh081_11: number;          // 金額
  fh081_12: string | null;   // 日期
}

export interface FH110 {
  fh110_01: string;          // 單號
  fh110_11: string | null;   // 請款日期
  fh110_12: number;          // 請款淨額
  fh110_13: number;          // 請款總額
  fh110_14: string;          // 狀態
  fh110_15: string;          // 受款人代號
  fh110_16: string;          // 公司代號
  fh110_17: string;          // 備註
  fh110_18: string;          // 備註2
  fh110_19: string | null;   // 支票到期日1
  fh110_20: string;          // 沖帳狀態
  fh110_21: number;          // 已付款總額
  fh110_22: string;          // 表單類型
  fh110_23: string | null;   // 需要日期
  fh110_241: boolean;
  fh110_242: boolean;        // 取消禁背
  fh110_25: string;          // 幣別
  fh110_26: number;          // 匯率
  fh110_27: string;          // 票款別
  fh110_28: number;          // 其他費用
  fh110_29: string | null;   // 預計沖銷日
  fh110_30: string | null;   // 支票到期日2
  fh110_31: number;          // 票面金額1
  fh110_32: number;          // 票面金額2
  fh110_37: string;          // 歸屬部門
  fh110_39: number;          // 明細總項次
  fh110_40: string;          // 隱藏欄位
  fh110_42: boolean;
  fh110_43: string;          // 取消禁背理由
  fh110_44: boolean;
  fh110_46: string;          // 支票號碼1
  fh110_47: string;          // 支票號碼2
  fh110_50: number;          // 暫借款類別(1=貨款/2=費用)
  fh110_51: string;          // 沖帳中狀態
  fh110_80: string;          // 審核狀態
  fh110_90: number;          // Version
  fh110_91: string;          // 建立人員
  fh110_92: string | null;   // 建立日期
  details?: FH111[];
  audit_records?: FH113[];
  write_off_records?: FH081[];
}

export interface ListResponse {
  data: FH110[];
  total: number;
  page: number;
  pageSize: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API Functions
// ============================================================

const BASE = '/api/pwh205';

export const pwh205Api = {
  list: async (page = 1, size = 20): Promise<ListResponse> => {
    const res = await apiClient.get(BASE, { params: { page, pageSize: size } });
    return res.data;
  },

  get: async (id: string): Promise<FH110> => {
    const res = await apiClient.get(`${BASE}/${id}`);
    return res.data;
  },

  create: async (master: Partial<FH110>, details: Partial<FH111>[]): Promise<FH110> => {
    const res = await apiClient.post(BASE, { master, details });
    return res.data;
  },

  update: async (id: string, master: Partial<FH110>, details: Partial<FH111>[]): Promise<FH110> => {
    const res = await apiClient.put(`${BASE}/${id}`, { master, details });
    return res.data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`${BASE}/${id}`);
  },

  submit: async (id: string): Promise<void> => {
    await apiClient.post(`${BASE}/${id}/submit`);
  },

  withdraw: async (id: string): Promise<void> => {
    await apiClient.post(`${BASE}/${id}/withdraw`);
  },

  approve: async (id: string): Promise<void> => {
    await apiClient.post(`${BASE}/${id}/approve`, { confirmed: true });
  },
};

export default pwh205Api;
